export const bindMethod = (add) => add ? 'addEventListener' : 'removeEventListener';
export const bindEmitterMethod = (add) => add ? 'on' : 'off';
